import { render, staticRenderFns } from "./EchartsReport.vue?vue&type=template&id=b4e874ac&scoped=true"
import script from "./EchartsReport.vue?vue&type=script&lang=js"
export * from "./EchartsReport.vue?vue&type=script&lang=js"
import style0 from "./EchartsReport.vue?vue&type=style&index=0&id=b4e874ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e874ac",
  null
  
)

export default component.exports